import { useNavigate } from '@tanstack/react-router';
import { useGetMe } from '@sara/api-client';
import { Button } from '@sara/ui/components/button';
import { writeLastOrgSlug } from '../../lib/last-org';
import { interviewsHomeSearch } from '../../router/tree';

export function OrgSelectorPage() {
  const navigate = useNavigate();
  const { data: me, isLoading } = useGetMe();

  if (isLoading || !me) return null;

  const memberships = me.memberships;

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-6">
      <section className="w-full max-w-md space-y-6">
        <header className="space-y-1 text-center">
          <h1 className="text-2xl font-semibold">Select an organization</h1>
          {memberships.length > 0 && (
            <p className="text-sm text-muted-foreground">
              You belong to multiple organizations. Pick one to continue.
            </p>
          )}
        </header>
        <ul className="flex flex-col gap-3">
          {memberships.map((m) => (
            <li key={m.id}>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={() => {
                  writeLastOrgSlug(m.organization.slug);
                  void navigate({
                    to: '/orgs/$orgSlug/sessions',
                    params: { orgSlug: m.organization.slug },
                    search: interviewsHomeSearch,
                  });
                }}
              >
                {m.organization.name}
              </Button>
            </li>
          ))}
        </ul>
        {memberships.length === 0 && (
          <p className="rounded-md border border-dashed p-4 text-center text-sm text-muted-foreground">
            You are not a member of any organization yet. Contact your admin.
          </p>
        )}
      </section>
    </main>
  );
}
